<template>
  <div class="progressbar">
    <div class="progressbar__fill" :style="styleBar">
      <div :class="{'faturamento-acumulado': value >= 22000,
                    'faturamento-acumulado--alavancado': diferencaMinima < 21000 && diferencaMinima > 0 && valuePrevisao < 97200  ,
                    'faturamento-acumulado--minimo': value < 22000,
                    'faturamento-acumulado--maximo': value > 22000 & value < 70000,
                    'faturamento-acumulado--maximo-mais-70': value > 70000,
                  }">

        <span class="faturamento-acumulado__legend" :class="{'hidden': !faturamentoAcumuladoLegenda}">faturamento acumulado</span>
        <span class="faturamento-acumulado__value">{{this.formatNumber(value)}}
          <img
          v-if="value > final"
          src="@/assets/icons/next.webp"
          alt="play"
          aria-disabled="true"></span>
      </div>
    </div>
    <div class="progressbar__fill-previsao" :style="styleBarPrevisao" v-if="valuePrevisao">
      <div
        :class="{
          'faturamento-acumulado-previsao--minimo': diferencaMinima < 21000,
          'faturamento-acumulado-previsao--menor': valuePrevisao < 50000,
          'faturamento-acumulado-previsao--alavancado-no-maximo': valuePrevisao > 50000 && value > 90000,
        }"
        class="faturamento-acumulado-previsao">
        <span class="faturamento-acumulado-previsao__legend">previsão em 2023</span>
        <span class="faturamento-acumulado-previsao__value">
          {{this.formatNumber(valuePrevisao)}}
          <img
          v-if="valuePrevisao > final"
          src="@/assets/icons/next.webp"
          alt="play"
          aria-disabled="true">
        </span>
      </div>
    </div>
    <div class="progressbar__fill-limite" :style="styleBarLimite">
      <div class="faturamento-limite">
        <span class="faturamento-limite__value">
          {{this.formatNumber(limite)}}
          <TooltipText
          :text="'Limite de faturamento'"
          :class-name="'marginl-40'"
          class="tooltip-limite"
          style="top: 1px;"
        />
        </span>
      </div>
    </div>
    <div class="progressbar__fill-limite-mais-vinte" :style="styleBarLimiteMaisVinte">
      <div class="faturamento-limite-mais-vinte">
        <span class="faturamento-limite-mais-vinte__value">
          {{this.formatNumber(limiteMaisVinte)}}
          <TooltipText
          :text="'Limite + 20%'"
          :class-name="'marginl-40'"
          class="tooltip-mais-vinte"
          style="top: 1px;"
        />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipText from '@/components/TooltipText'

export default {
  name: "progress-bar",
  components: {
    TooltipText
  },
  props: {
    init: {
      type: Number,
      default: 0
    },
    limite: {
      type: Number,
      default: null
    },
    limiteMaisVinte: {
      type: Number,
      default: null
    },
    final: {
      type: Number,
      default: 120000
    },

    value: {
      type: String,
      default: ''
    },
    valuePrevisao: {
      type: Number,
      default: null
    },
    faturamentoAcumuladoLegenda: {
      type: false,
      default: false
    }
  },
  data() {
    return {
      diferencaMinima: null,
    };
  },
  computed: {
    styleBar() {
      const progress = this.value > 120000 ? 120000 : this.value
      const percentage = (100 * progress) / this.final;
      return {
        width: `${percentage}%`
      };
    },
    styleBarPrevisao() {
      const progress = this.valuePrevisao > 120000 ? 120000 : this.valuePrevisao
      const percentage = (100 * progress) / this.final;
      const widthColor = (100 - percentage) + 100
      return {
        width: `${percentage}%`,
        background: `linear-gradient(90deg,#04C377,#B5C943,#FFCB2E,#FF5233,#712A00 ) 0/${widthColor}%`
      };
    },
    styleBarLimite() {
      const percentage = (100 * this.limite) / this.final;
      return {
        width: `${percentage}%`
      };
    },
    styleBarLimiteMaisVinte() {
      const percentage = (100 * this.limiteMaisVinte) / this.final;
      return {
        width: `${percentage}%`
      };
    }
  },
  methods: {
    formatNumber(value) {
      return  new Intl
              .NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
              .format(value)
    }
  },
  mounted() {
    this.diferencaMinima = this.valuePrevisao - this.value
  },
};
</script>

<style lang="scss" src="./ProgressBar.styles.scss" scoped></style>
